// @flow
import { getAttributionData, recordAttributionAnalytics } from '../../redux/modules/analytics';
import { bindActionCreators } from 'redux';
import { Component } from 'react';
import { connect } from 'react-redux';
import isEqual from 'react-fast-compare';

const mapStateToProps = state => {
    return {
        attributionData: getAttributionData(state),
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            recordAttributionAnalytics,
        },
        dispatch
    );

type Props = {|
    attributionData: any,
    recordAttributionAnalytics: Function,
|};

class SegmentTracker extends Component<Props> {
    componentDidMount() {
        if (this.props.attributionData.bidderId !== -1 && this.props.attributionData.bidderId !== 0) {
            this.props.recordAttributionAnalytics(this.props.attributionData);
        }
    }

    shouldComponentUpdate = nextProps => !isEqual(this.props, nextProps);

    componentDidUpdate(prevProps: Props) {
        if (
            prevProps.attributionData.bidderId !== this.props.attributionData.bidderId &&
            this.props.attributionData.bidderId !== -1 &&
            this.props.attributionData.bidderId !== 0
        ) {
            this.props.recordAttributionAnalytics(this.props.attributionData);
        }
    }

    render() {
        return null;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SegmentTracker);
